/**
 * Naive serializer and deserializer for StaticPartVersionData.  It's naive because it doesn't leverage any
 * technology to do its job and all it's really doing is satisfying a really basic interface.  It does no
 * type checking on read, and just unpacks whatever data it's given.
 */
export class NaiveStaticPartVersionSerde {
    serializationSchemaTag = "v0";
    /** @inheritDoc */
    intoStored(data) {
        return {
            __metadata: {
                schemaTag: this.serializationSchemaTag,
            },
            ...data,
        };
    }
    /** @inheritDoc */
    fromStored(data) {
        /**
         * This is a trick.  Because StoredStaticPartVersionData _strictly_ extends IPartVersionData, we can
         * just cast away the additional type information and call it a day.
         */
        return data;
    }
}
//# sourceMappingURL=NaiveStaticPartVersionSerde.js.map